import type { FaireProductEntity } from "../../entity_types/product";

export const p_vk3yc9xfvd: FaireProductEntity = {
  token: "p_vk3yc9xfvd",
  type: "product",
  name: "Red, White, & Blue Sports Necklace",
  brandToken: "b_al75e43rzb",
  brandName: "Golden Thread",
  imageUrl:
    "https://cdn.faire.com/fastly/1ab826cd12db37bfe08d4ffc87cbdf9dea04485954da0d26e4798a41d539fa34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a4977dc5ae8746d466515f7ad047b99f36a837c4e200064e075e313aab84f4e.jpeg",
    "https://cdn.faire.com/fastly/a8325b918958e576daf1c073adcb48835922897456d44154060798131dfadc23.jpeg",
  ],
  priceDollars: 6,
  description:
    "Look like the pros in our Rope Baseball Necklace -- the triple twisted tornado rope style is a must-have in the MLB. It is18-inches long and perfect for boys of all ages! Show your team spirit at a big league game or on the little league fields! These necklaces are waterproof and can be washed. Cotton rope with black locking plastic closure. \n*Team discounts available and other colors available upon request.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:51.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
